import { isPasskeyAvailableOnThisDevice } from './passkeyDevice';
import { SAVED_ACCOUNTS_KEY } from './storageKeys';

export interface SavedAccount {
  id: string;
  name: string;
  role: string;
  email: string;
  avatar: string;
  lastAccess: number;
  authMethod?: 'google' | 'email';
  hasPasskey?: boolean;
  localStatus?: 'active' | 'pending_security';
  statusLabel?: string;
  cargo?: string;
}

export function readSavedAccounts(): SavedAccount[] {
  try {
    const stored = window.localStorage.getItem(SAVED_ACCOUNTS_KEY);
    const parsed = stored ? JSON.parse(stored) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeSavedAccounts(accounts: SavedAccount[]): boolean {
  try {
    window.localStorage.setItem(SAVED_ACCOUNTS_KEY, JSON.stringify(accounts));
    return true;
  } catch {
    return false;
  }
}

export function saveAccountToLocal(userData: any, authMethod?: 'google' | 'email'): boolean {
  try {
    const accounts = readSavedAccounts();
    const hasPasskey = isPasskeyAvailableOnThisDevice(userData.email);

    const newAccount: SavedAccount = {
      id: userData.id,
      name: userData.nome,
      role: userData.role || userData.perfil,
      email: userData.email,
      avatar: userData.fotoUrl || `https://ui-avatars.com/api/?name=${encodeURIComponent(userData.nome)}&background=random&color=fff`,
      lastAccess: Date.now(),
      authMethod: authMethod || 'email',
      hasPasskey,
      localStatus: userData.localStatus || 'active',
      statusLabel: userData.statusLabel,
      cargo: userData.cargo || undefined,
    };

    const updated = accounts.filter((account) => account.email !== newAccount.email);
    updated.push(newAccount);
    return writeSavedAccounts(updated);
  } catch (e: any) {
    console.error(`Erro ao salvar conta no localStorage: ${e?.message || e}`);
    return false;
  }
}
